import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { ReactComponent as Undo } from "../../../icons/undo.svg";
import { RuvnlTitle } from "../components";
import { TabSwitcher } from "../Raj_Dashboard";
import Hamburger from "../../../components/Hamburger";
import { ReactComponent as GNAiIcon } from "../../../icons/gnai_logo.svg";
import { PageHeader } from "../../../components/Page";
import CreateNewSessionModal from "./Resource/Popup/CreateSessionPopup";
import { useOptimizerNavigation } from "./utility/useOptimizerNavigation";
import { getProcurementDemoSession } from "../../../Rest_api/DemoRestApi";
import { useDispatch } from "react-redux";
import { setOptimizerDemoDateRange } from "../../../store/state/GNAOptimizer/DemoOptimizer/OptimizerDate";
import { setOptimizerDemoSession } from "../../../store/state/GNAOptimizer/DemoOptimizer/OptimizerSession";
import { setOptimizerDemoSessionToken } from "../../../store/state/GNAOptimizer/DemoOptimizer/OptimizerSessionToken";

export default function RuvitlOptim() {
  const [showPreviousSession, setShowPreviousSession] = React.useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { goToPreviousStage } = useOptimizerNavigation();

  const GotoPreviousStage = async () => {
    setLoading(true);
    await goToPreviousStage(getProcurementDemoSession);
    setLoading(false);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    async function OptimizerRuvnlSession() {
      const data = await getProcurementDemoSession();
      if (data) {
        dispatch(
          setOptimizerDemoDateRange({
            startDate: data.start_date,
            endDate: data.end_date,
          }),
        );
        dispatch(setOptimizerDemoSession(data.session));
        dispatch(setOptimizerDemoSessionToken(data.session_token));
        setShowPreviousSession(true);
      } else {
        setShowPreviousSession(false);
      }
    }
    OptimizerRuvnlSession();
  }, [dispatch]);

  return (
    <>
      <div className="w-full">
        <PageHeader
          leftComponent={
            <div className="flex flex-row md:gap-x-4 gap-x-2 items-center">
              <GNAiIcon width={80} />
              <Hamburger />
              <TabSwitcher />
              <h1 className="text-[16px] text-[#6F6D7C]">
                PowerMarketizer
              </h1>
            </div>
          }
          middleComponent={<RuvnlTitle />}
        />
        <div className="tabContent">
          {" "}
          <div className="h-[calc(-90px+100vh)] p-4">
            <div className="w-full h-full">
              <div className="meritEngine w-full h-full flex flex-col items-center justify-center px-4 rounded-xl relative bg-mod bg-bottom bg-no-repeat bg-cover">
                <div className=" ">
                  <div className="text-center !my-20">
                    <h1 className="text-5xl  font-semibold text-[#F1935C] tracking-wider">
                      PowerMarketizer
                    </h1>

                    <h2 className="text-5xl font-semibold text-[#525062] mt-8 tracking-wider">
                      Energy Procurement Optimisation
                    </h2>

                    <p className="text-[#525062] font-normal mt-4 text-4xl tracking-wider">
                      Maximise Value, Minimise Cost, Procure Smarter
                    </p>

                    <p className="text-[#F1935C] font-semibold mt-6 text-3xl tracking-wide">
                      Powered by{" "}
                      <span className="text-[#F1935C] font-bold">GNA</span>
                      <span className="text-[#6F6D7C]">i</span>
                    </p>

                    {/* Buttons */}
                    <div className="flex gap-10 justify-center !mt-16 flex-wrap">
                      <button
                        onClick={() => setModalOpen(true)}
                        className="flex items-center gap-3 text-base rounded-full px-3 py-2 bg-[#F1935C] shadow-lg text-[#fff] font-medium border border-[#F1935C] hover transition transform hover:scale-105"
                      >
                        <span>Create a New Session</span>
                        <div className="w-[40px] h-[40px] bg-white rounded-full flex items-center justify-center">
                          <ArrowRight
                            strokeWidth={3}
                            className="w-5 h-5 text-[#F1935C]"
                          />
                        </div>
                      </button>

                      {showPreviousSession && (
                        <button
                          onClick={GotoPreviousStage}
                          className="flex items-center gap-1 text-base rounded-3xl px-3 py-2 bg-[#FFF] text-[#8C8A96] font-medium border border-gray-300 hover transition transform hover:scale-105"
                        >
                          {loading ? (
                            <span>Loading...</span>
                          ) : (
                            <span>Continue to Previous Session</span>
                          )}
                        </button>
                      )}
                    </div>

                    {showPreviousSession && (
                      <>
                        {" "}
                        <div className="flex items-center justify-center mt-8">
                          {/* <button
                            title="Comming Soon"
                            // onClick = {GotoArchivePage}
                            className="flex items-center gap-2 px-7 py-5 text-lg  border-[#34656D] bg-transprent text-[#34656D] font-medium"
                          >
                            <Undo className="w-5 h-5" />
                            Go to Archive
                          </button> */}
                        </div>
                      </>
                    )}

                    {/* Archive link */}
                  </div>
                </div>
              </div>

              <CreateNewSessionModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
              />
            </div>
          </div>
          <div className="gna-footer-container">
            <div className="grid grid-cols-2 justify-between gap-5 ">
              {/* <p className="gna-footer-text"> </p> */}

              <p className="gna-footer-text col-span-1 text-start">
                Powered by <strong>GNA Energy</strong>
              </p>
              <strong className="gna-footer-text col-span-1 text-end">
                Beta Version
              </strong>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
